import React, { FC, useEffect, useState } from 'react';
import { Button, Card, Drawer } from 'antd';

import { useUpdateStepsMutation } from 'app/services/edpApiV1/vacationApplication';
import { TAddApplicationStepResponse } from 'shared/types/vacation-schedule.types';
import { useNotifications } from 'shared/hooks/use-notifications';
import { SerializedError } from '@reduxjs/toolkit';
import style from './index.module.scss';

type TProps = {
  stepInfo?: TAddApplicationStepResponse;
  onDrawerClose: () => void;
  drawerOpen: boolean;
};

const AcceptSettingsDrawer: FC<TProps> = ({ drawerOpen, onDrawerClose, stepInfo }) => {
  const [steps, setSteps] = useState<TAddApplicationStepResponse>();
  const [stepMutation, { data, isSuccess, isError, error, reset }] = useUpdateStepsMutation();

  useEffect(() => {
    if (stepInfo) {
      setSteps({ ...stepInfo });
    }
  }, [stepInfo]);
  useNotifications(isSuccess, isError, 'Этапы согласования изменены', (error as SerializedError)?.message, reset);
  const addStep = async () => {
    if (steps) {
      const step = {
        ...steps,
        agreementDepth:
          steps.agreementDepth < steps.agreementDepthMax ? ++steps.agreementDepth : steps.agreementDepthMax,
      };
      setSteps(step);
    }
  };

  const deleteStep = async () => {
    if (steps) {
      const step = {
        ...steps,
        agreementDepth: steps.agreementDepth > 1 ? --steps.agreementDepth : 1,
      };
      setSteps(step);
    }
  };

  const onSaveSteps = () => {
    if (steps) {
      stepMutation({ agreementDepth: steps.agreementDepth, divisionId: steps.id });
      onDrawerClose();
    }
  };

  return (
    <Drawer
      title="Настройка согласования"
      width={720}
      onClose={onDrawerClose}
      open={drawerOpen}
      extra={
        <div className={style.buttons}>
          <Button onClick={onDrawerClose}>Отмена</Button>
          <Button onClick={onSaveSteps} type="primary">
            Сохранить
          </Button>
        </div>
      }
    >
      <div className={style.top}>
        <b>Маршрут согласования</b>

        <div className={style.buttons}>
          <Button onClick={deleteStep} disabled={steps?.agreementDepth === 1}>
            Удалить
          </Button>
          <Button type="primary" onClick={addStep} disabled={steps?.agreementDepth === steps?.agreementDepthMax}>
            Добавить
          </Button>
        </div>
      </div>
      <div className={style['heads-area']}>
        {steps?.agreementDepthList.map((elem, index) =>
          index + 1 <= steps.agreementDepth ? (
            <div className={style['step-card']} key={elem.id}>
              {elem.name}
            </div>
          ) : null,
        )}
      </div>
    </Drawer>
  );
};

export default AcceptSettingsDrawer;
